import { SVGProps } from 'react';

export const RangeOperatorEqualTo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="15"
    viewBox="0 -3 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9336 0V2.72218H0V0H11.9336ZM11.9336 5.82931V8.55149H0V5.82931H11.9336Z"
      fill="currentColor"
    />
  </svg>
);
